export default __webpack_public_path__ + "static/media/Ies_Panel1_ENG_movil.478f17fa.jpg";